export const styles = theme => ({
    videoResponsive: {
        overflow: "hidden",
        paddingBottom: "56.25%",
        position: "relative" as const,
        marginTop: 64,
        marginLeft: 30,
        height: 0,
        "& iframe": {
            left: 0,
            top: 0,
            height: "100%",
            width: "100",
            position: "absolute"
        }
    }
});